import { MutableRefObject } from 'react';
import { useAnimationContext } from '../../../context/useAnimationContext';
import { useClassRemove } from '../useClassRemove';
import { BACKGROUND, CONTAINER } from '../../../context/constants';
import { useDeviceSelector } from 'js/store/hooks';
import { pick } from 'ramda';

export const useRoundIconsClassRemoval = (
    classToRemove: string = '',
    refs: MutableRefObject<HTMLDivElement | null>[]
) => {
    const { isPrevAnimationEndMap } = useAnimationContext();
    const { isPortrait } = useDeviceSelector(pick(['isPortrait']));

    return useClassRemove(
        classToRemove,
        refs,
        isPortrait ?
            isPrevAnimationEndMap[BACKGROUND] :
            isPrevAnimationEndMap[CONTAINER]
        );
};
